export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_08.b88cef8b.png";